import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'

//import './registerServiceWorker'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import NProgress from 'nprogress'
import VueAgile from 'vue-agile' //slider
import * as VueGoogleMaps from 'vue2-google-maps'



// require styles
import 'swiper/dist/css/swiper.css'
import '../node_modules/nprogress/nprogress.css'

//qty input
import VueNumberInput from '@chenfengyuan/vue-number-input';

//money 
import VueCurrencyFilter from 'vue-currency-filter'

//datetime
import moment from 'moment'
import BackToTop from 'vue-backtotop'

import { VueStars } from "vue-stars"

import zoom from 'vue-image-zoom';
import 'vue-image-zoom/dist/vue-image-zoom.css';

Vue.use(zoom);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.use(VueGoogleMaps, {
  load: {
    key: '',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})
Vue.use(BackToTop)
Vue.use(VueNumberInput)
Vue.use(VueCurrencyFilter, {
  symbol: 'S/', // El símbolo, por ejemplo €
  thousandsSeparator: ',', // Separador de miles
  fractionCount: 2, // ¿Cuántos decimales mostrar?
  fractionSeparator: '.', // Separador de decimales
  symbolPosition: 'front', // Posición del símbolo. Puede ser al inicio ('front') o al final ('') es decir, si queremos que sea al final, en lugar de front ponemos una cadena vacía ''
  symbolSpacing: true // Indica si debe poner un espacio entre el símbolo y la cantidad
})

Vue.component("vue-stars", VueStars)

Vue.use(VueAwesomeSwiper)
Vue.use(VueAgile) // slider use
Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

Vue.filter('esDate', function(value) {
  if (value) {
    moment.locale('es')
    return moment(String(value)).format('D MMMM YYYY');
  }
});

Vue.filter('striphtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});


router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})
// eslint-disable-next-line no-unused-vars
let vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')